import { Ionicons } from '@expo/vector-icons'
import { useHeaderHeight } from '@react-navigation/stack'
import moment from 'moment'
import { Box, HStack, Icon, Image, Input, Text, VStack } from 'native-base'
import React from 'react'
import {
    Dimensions, FlatList, TouchableOpacity
} from 'react-native'


export default function MemberList(props) {
    const { t, members } = props
    const headerHeight = useHeaderHeight();

    const renderMembersView = (object) => {
        const { item } = object
        const { _id, createdAt, username, email, avatar, credit } = item
        return (
            <TouchableOpacity onPress={() => props.onMemberPress(_id)}>
                <HStack p={2} alignItems={'center'}>
                    <Image size={'md'} resizeMode={'cover'} bg={'gray.400'} borderRadius={40} source={{ uri: avatar }} fallbackSource={{ uri: "https://shopper-api.shopper.com.hk/Storage/user/avatar/default.jpg", }} />
                    <VStack w={'100%'}>
                        <Text isTruncated px={2} py={1} color={'black'}>{`${username}`}</Text>
                        <Text isTruncated px={2} py={1} color={'black'} fontSize={'xs'}>{`${email}`}</Text>
                        <Text isTruncated px={2} py={1} color={'black'} fontSize={'xs'}>{t('joinDate', { createdAt: moment(createdAt).format('YYYY年MM月DD日') })}</Text>
                        <Text isTruncated px={2} py={1} color={'primary.100'} fontSize={'xs'}>{`${credit} 積分`}</Text>
                    </VStack>
                </HStack>
            </TouchableOpacity>
        )
    }


    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} p={2}>
            <VStack px={6} py={2} space={2}>
                <Input
                    placeholder="Search"
                    variant="filled"
                    width="100%"
                    bg="gray.200"
                    borderRadius={10}
                    py={1}
                    px={2}
                    _web={{
                        _focus: { borderColor: 'muted.300', style: { boxShadow: 'none' } },
                    }}
                    InputLeftElement={<Icon size='sm' ml={2} size={5} color="gray.400" as={<Ionicons name="ios-search" />} />}
                    onChangeText={(v) => props.onChangeText(v)}
                />
            </VStack>
            <FlatList
                ItemSeparatorComponent={() => {
                    return (
                        <Box
                            borderBottomWidth={1}
                            borderBottomColor={'gray.200'}
                        />
                    )
                }}
                style={{ backgroundColor: 'white' }}
                onEndReached={() => props.onEndReached()}
                data={members}
                renderItem={(object) => renderMembersView(object)}
                keyExtractor={(item, index) => index.toString()}
            />
        </Box>
    )
}